<base-site-layout [heading]="heading | translate" [headerIcon]="icon" [loading]="store.loading()">
    <base-site-layout-action>
        <div class="row justify-content-end">
            <div class="col-auto">
                <button mat-icon-button [title]="'Einstellungen' | translate" (click)="openSettings()">
                    <em class="fas fa-cog fa-2x"></em>
                </button>
            </div>
        </div>
    </base-site-layout-action>

    <div class="pb-4">
        <iim-table
            theme="material"
            [headerSticky]="true"
            [tableHeaders]="header"
            [tableContent]="tableContent"
            [tableActions]="actions"
            [tableInfo]="infoRow"
            [filtersActive]="true"
            (onSort)="onSortChange($event)"
        >
            <iim-table-filter-preview-entry
                [label]="'Code' | translate"
                [content]="filterDto().code"
                (removed)="clearCode()"
            ></iim-table-filter-preview-entry>

            <iim-table-filter-preview-entry
                [label]="'Name' | translate"
                [content]="filterDto().name"
                (removed)="clearName()"
            ></iim-table-filter-preview-entry>

            <iim-table-filter-preview-entry
                [label]="'Buchungskreis' | translate"
                [content]="companyCodesContent()"
                (removed)="clearCompanyCodes()"
            ></iim-table-filter-preview-entry>

            <iim-table-filter-preview-entry
                [label]="'Warengruppe' | translate"
                [content]="materialGroupCodesContent()"
                (removed)="clearMaterialGroupCodes()"
            ></iim-table-filter-preview-entry>

            <iim-table-filter-preview-entry
                [label]="'Mitarbeiter' | translate"
                [content]="memberIdsContent()"
                (removed)="clearMembers()"
            ></iim-table-filter-preview-entry>

            <iim-table-filter-preview-entry
                [label]="'Status' | translate"
                [content]="statusContent()"
                (removed)="clearStatus()"
            ></iim-table-filter-preview-entry>

            <ng-template #actions>
                <div class="col-md-auto col-sm-12 my-1 my-md-0 my-lg-0 my-xl-0 p-0">
                    <div class="row justify-content-end g-1">
                        <div class="col-md-auto col-sm-12 mb-1 mb-md-0">
                            <div class="input-group">
                                <span class="input-group-text"><em class="fas fa-search"></em></span>
                                <input
                                    type="text"
                                    class="form-control"
                                    [placeholder]="'Code' | translate"
                                    [formControl]="codeControl"
                                />
                                @if (codeControl.value) {
                                    <span class="input-group-text cursor-pointer" (click)="codeControl.setValue('')">
                                        <em class="fas fa-trash"></em>
                                    </span>
                                }
                            </div>
                        </div>

                        <div class="col-md-auto col-sm-12 mb-1 mb-md-0">
                            <div class="input-group">
                                <span class="input-group-text"><em class="fas fa-search"></em></span>
                                <input
                                    type="text"
                                    class="form-control"
                                    [placeholder]="'Name' | translate"
                                    [formControl]="nameControl"
                                />
                                @if (nameControl.value) {
                                    <span class="input-group-text cursor-pointer" (click)="nameControl.setValue('')">
                                        <em class="fas fa-trash"></em>
                                    </span>
                                }
                            </div>
                        </div>

                        <div class="col-md-auto col-sm-12">
                            <div class="input-group">
                                <select
                                    class="form-select padding-vertical-0"
                                    [value]="filterDto().status"
                                    (change)="onQuickStatusChange($event)"
                                >
                                    <option [value]="statusFilterChoices.ALL">- {{ 'Status' | translate }} -</option>
                                    <option [value]="statusFilterChoices.ACTIVE">{{ 'Aktiv' | translate }}</option>
                                    <option [value]="statusFilterChoices.INACTIVE">{{ 'Inaktiv' | translate }}</option>
                                </select>
                                @if (filterDto().status !== statusFilterChoices.ALL) {
                                    <span class="input-group-text cursor-pointer" (click)="clearStatus()">
                                        <em class="fas fa-trash"></em>
                                    </span>
                                }
                            </div>
                        </div>

                        <div class="col-md-auto col-sm-12">
                            <button class="btn btn-primary w-100" (click)="openCreate()">
                                <em class="fas fa-plus"></em>
                            </button>
                        </div>
                    </div>
                </div>
            </ng-template>

            <ng-template #infoRow>
                <iim-table-filter-custom xlClass="col-xl-4" [fullWidth]="true" [label]="'Buchungskreis' | translate">
                    <iim-multiselect
                        [placeholder]="'Buchungskreise suchen' | translate"
                        [formControl]="companyCodesControl"
                        [preferences]="multiselectPreferences"
                    >
                        @for (option of store.companyCodeOptions(); track option.code) {
                            <iim-autocomplete-option [value]="option">
                                {{ option.valueDisplay }}
                                @if (!option.active) {
                                    <span class="text-muted">({{ 'Inaktiv' | translate }})</span>
                                }
                            </iim-autocomplete-option>
                        }
                    </iim-multiselect>
                </iim-table-filter-custom>

                <iim-table-filter-custom xlClass="col-xl-4" [fullWidth]="true" [label]="'Warengruppe' | translate">
                    <iim-multiselect
                        [placeholder]="'Warengruppen suchen' | translate"
                        [formControl]="materialGroupCodesControl"
                        [preferences]="multiselectPreferences"
                    >
                        @for (option of store.materialGroupOptions(); track option.code) {
                            <iim-autocomplete-option [value]="option">
                                {{ option.valueDisplay }}
                                @if (!option.active) {
                                    <span class="text-muted">({{ 'Inaktiv' | translate }})</span>
                                }
                            </iim-autocomplete-option>
                        }
                    </iim-multiselect>
                </iim-table-filter-custom>

                <iim-table-filter-custom xlClass="col-xl-4" [fullWidth]="true" [label]="'Mitarbeiter' | translate">
                    <iim-multiselect
                        [placeholder]="'Mitarbeiter suchen' | translate"
                        [formControl]="memberIdsControl"
                        [preferences]="multiselectPreferences"
                    >
                        @for (member of store.memberOptions(); track member.id) {
                            <iim-autocomplete-option [value]="member">
                                {{ member.valueDisplay }}
                                @if (!member.active) {
                                    <span class="text-muted">({{ 'Inaktiv' | translate }})</span>
                                }
                            </iim-autocomplete-option>
                        }
                    </iim-multiselect>
                </iim-table-filter-custom>
            </ng-template>

            <ng-template #header>
                <iim-table-header-column name="CODE" xlClass="col-xl-1" sortingHeaderName="code">
                    {{ 'Code' | translate }}
                </iim-table-header-column>
                <iim-table-header-column name="NAME" xlClass="col-xl-2" sortingHeaderName="name">
                    {{ 'Name' | translate }}
                </iim-table-header-column>
                <iim-table-header-column name="BK" xlClass="col-xl-2">
                    {{ 'Buchungskreis' | translate }}
                </iim-table-header-column>
                <iim-table-header-column name="WG" xlClass="col-xl-2">
                    {{ 'Warengruppe' | translate }}
                </iim-table-header-column>
                <iim-table-header-column name="MEMBERS" xlClass="col-xl-3">
                    {{ 'Mitarbeiter' | translate }}
                </iim-table-header-column>
                <iim-table-header-column name="STATUS" xlClass="col-xl-1">
                    {{ 'Status' | translate }}
                </iim-table-header-column>
                <iim-table-header-column name="ACTION" xlClass="col-xl-1" [alignRight]="true">
                    {{ 'Aktion' | translate }}
                </iim-table-header-column>
            </ng-template>

            <ng-template #tableContent>
                @if (store.loading()) {
                    <div class="row py-5 justify-content-center align-items-center">
                        <div class="col d-flex justify-content-center align-items-center">
                            <iim-spinner size="medium"></iim-spinner>
                        </div>
                    </div>
                } @else if (filteredRows().length > 0) {
                    @for (row of filteredRows(); track row.id) {
                        <iim-table-row>
                            <iim-table-column name="CODE" xlClass="col-xl-1">
                                <div class="fw-bold">{{ row.code }}</div>
                            </iim-table-column>
                            <iim-table-column name="NAME" xlClass="col-xl-2">
                                <div class="fw-bold">{{ row.name }}</div>
                            </iim-table-column>
                            <iim-table-column name="BK" xlClass="col-xl-2">
                                @if (row.companyCodes.length === 0) {
                                    <span class="text-muted fst-italic">—</span>
                                } @else {
                                    <span class="purchasing-group-code-cell" [title]="row.companyCodes.join(' ')">
                                        @for (bk of row.companyCodes; track bk) {
                                            <span class="purchasing-group-code-badge">{{ bk }}</span>
                                        }
                                    </span>
                                }
                            </iim-table-column>
                            <iim-table-column name="WG" xlClass="col-xl-2">
                                @if (row.materialGroupCodes.length === 0) {
                                    <span class="text-muted fst-italic">—</span>
                                } @else {
                                    <span class="purchasing-group-code-cell" [title]="row.materialGroupCodes.join(' ')">
                                        @for (wg of row.materialGroupCodes; track wg) {
                                            <span class="purchasing-group-code-badge is-wg">{{ wg }}</span>
                                        }
                                    </span>
                                }
                            </iim-table-column>
                            <iim-table-column name="MEMBERS" xlClass="col-xl-3">
                                @if (row.memberDisplays.length === 0) {
                                    <span class="text-muted fst-italic">—</span>
                                } @else {
                                    <span class="purchasing-group-code-cell">
                                        @for (display of row.memberDisplays; track $index) {
                                            <span class="purchasing-group-code-badge is-member">{{ display }}</span>
                                        }
                                    </span>
                                }
                            </iim-table-column>
                            <iim-table-column name="STATUS" xlClass="col-xl-1">
                                <span class="badge" [ngClass]="row.active ? 'bg-success' : 'bg-secondary'">
                                    {{ row.active ? ('Aktiv' | translate) : ('Inaktiv' | translate) }}
                                </span>
                            </iim-table-column>
                            <iim-table-column name="ACTION" xlClass="col-xl-1" [alignRight]="true">
                                <button
                                    type="button"
                                    class="btn btn-outline-dark btn-sm"
                                    (click)="openDetails(row.id)"
                                >
                                    <em class="fas fa-eye pe-1"></em>
                                    {{ 'Details' | translate }}
                                </button>
                            </iim-table-column>
                        </iim-table-row>
                    }
                } @else {
                    <div class="col margin-top-10">
                        <div class="row justify-content-center">
                            <div class="col-6 alert alert-info text-center text-primary">
                                {{ 'Keine Datensätze gefunden' | translate }}
                            </div>
                        </div>
                    </div>
                }
            </ng-template>
        </iim-table>
    </div>
</base-site-layout>
